module.exports = __webpack_public_path__ + "img/down.da8e6e37.svg";